import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { isDataLineSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const mapFilterData = (data: IDataLineSearchForm): IDataLineSearchPost | {} => {
  const newData: IDataLineSearchForm = {...data};
  if (isDataLineSearchFormEmpty(data) || data == undefined) { return {} };

  const removedUnusedFilters = filterNonEmptyValues(newData);
  return removedUnusedFilters;
}

const getLineDownloadExcel = ( {data} : {data: IDataLineSearchForm}): Promise<string> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;

  return axiosDefaultApi.post(`api/Search/ExportToExcel/DataLines?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData, header);
};

type QueryFnType = typeof getLineDownloadExcel;

type UseGetLineDownloadExcelOptions = {
  data: IDataLineSearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useGetLineDownloadExcel = ({ config }: UseGetLineDownloadExcelOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου excel των γραμμων data.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading data line excel:', error);
    },
    onSuccess: () => {
      console.log('DataLine excel downloaded successfully.');
    },
    ...config,
    mutationFn: getLineDownloadExcel,
  })
}